
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DeleteRecentSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clearAll"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"psxSearchTerm"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pesSearchTerm"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"planYear"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteRecentSearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clearAll"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clearAll"}}},{"kind":"Argument","name":{"kind":"Name","value":"psxSearchTerm"},"value":{"kind":"Variable","name":{"kind":"Name","value":"psxSearchTerm"}}},{"kind":"Argument","name":{"kind":"Name","value":"pesSearchTerm"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pesSearchTerm"}}},{"kind":"Argument","name":{"kind":"Name","value":"createdDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"planYear"},"value":{"kind":"Variable","name":{"kind":"Name","value":"planYear"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchDetails"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"psxSearchTerm"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pesSearchTerm"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bhProgramFacilityAgg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"behavioralProgramId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"searchType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"category"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"latitude"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"longitude"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"coverageType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gender"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"aoeCodes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pseudoVerticals"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"virtualCare"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isMixedSearchSuggestion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"specialtyCategories"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isUserTextSearch"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"faultCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"faultCodeDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":791}};
    doc.loc.source = {"body":"query DeleteRecentSearch(\n  $clearAll: Boolean!\n  $psxSearchTerm: String\n  $pesSearchTerm: String\n  $createdDate: String\n  $planYear: Int\n  $userId: String\n) {\n  deleteRecentSearch(\n    clearAll: $clearAll\n    psxSearchTerm: $psxSearchTerm\n    pesSearchTerm: $pesSearchTerm\n    createdDate: $createdDate\n    planYear: $planYear\n    userId: $userId\n  ) {\n    searchDetails {\n      createdDate\n      psxSearchTerm\n      pesSearchTerm\n      bhProgramFacilityAgg\n      behavioralProgramId\n      searchType\n      category\n      latitude\n      longitude\n      location\n      coverageType\n      gender\n      aoeCodes\n      pseudoVerticals\n      virtualCare\n      isMixedSearchSuggestion\n      specialtyCategories\n      isUserTextSearch\n    }\n    faultCode\n    faultCodeDescription\n    status\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["DeleteRecentSearch"] = oneQuery(doc, "DeleteRecentSearch");
        
